exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".forgotPasswordPage .forgotOwl{width:150px;height:auto;display:block;margin:0 auto;margin-bottom:10px}.forgotPasswordPage .resetForm{width:400px;margin:0 auto;margin-bottom:20px}.forgotPasswordPage .btnLine{margin-top:1em;margin-bottom:1em}.forgotPasswordPage .resetMessage{transition:height .4s;overflow:hidden;color:#888;margin-top:5px;margin-left:12px;font-size:.8em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/logins/forgot_password_page.scss
// module id = 1345
// module chunks = 0